// Class: starling.textures.ConcreteRectangleTexture

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $bind = require("./../../bind_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_textures_ConcreteTexture() {return require("./../../starling/textures/ConcreteTexture");}
function starling_core_Starling() {return require("./../../starling/core/Starling");}
function Std() {return require("./../../Std");}
function Reflect() {return require("./../../Reflect");}
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}
function haxe_Timer() {return require("./../../haxe/Timer");}
function openfl_events_Event() {return $import(require("openfl/events/Event"));}

// Constructor

var ConcreteRectangleTexture = function(base,format,width,height,premultipliedAlpha,optimizedForRenderTexture,scale) {
	if(scale == null) {
		scale = 1;
	}
	if(optimizedForRenderTexture == null) {
		optimizedForRenderTexture = false;
	}
	(starling_textures_ConcreteTexture().default).call(this,base,format,width,height,false,premultipliedAlpha,optimizedForRenderTexture,scale);
}

// Meta

ConcreteRectangleTexture.__name__ = "starling.textures.ConcreteRectangleTexture";
ConcreteRectangleTexture.__isInterface__ = false;
ConcreteRectangleTexture.__super__ = (starling_textures_ConcreteTexture().default);
ConcreteRectangleTexture.prototype = $extend((starling_textures_ConcreteTexture().default).prototype, {
	uploadBitmapData: function(data,async) {
		if(async != null) {
			this._textureReadyCallback = async;
		}
		this.upload(data,async != null);
		this.setDataUploaded();
	},
	createBase: function() {
		return (starling_core_Starling().default).get_current().get_context().createRectangleTexture((Std().default).int(this.get_nativeWidth()),(Std().default).int(this.get_nativeHeight()),this.get_format(),this.get_optimizedForRenderTexture());
	},
	get_rectBase: function() {
		return this.get_base();
	},
	upload: function(source,isAsync) {
		if(isAsync) {
			this.uploadAsync(source);
			this.get_base().addEventListener("textureReady",$bind(this,this.onTextureReady));
			this.get_base().addEventListener("error",$bind(this,this.onTextureReady));
		} else {
			this.get_rectBase().uploadFromBitmapData(source);
		}
	},
	uploadAsync: function(source) {
		var _gthis = this;
		if(ConcreteRectangleTexture.sAsyncUploadEnabled) {
			var method = (Reflect().default).field(this.get_base(),"uploadFromBitmapDataAsync");
			try {
				(Reflect().default).callMethod(this.get_base(),method,[source]);
			} catch( error ) {
				var error1 = ((error) instanceof (js__$Boot_HaxeError().default)) ? error.val : error;
				if(((error1) instanceof (openfl_errors_Error().default))) {
					var error2 = error1;
					if(error2.errorID == 3708 || error2.errorID == 1069) {
						ConcreteRectangleTexture.sAsyncUploadEnabled = false;
					} else {
						throw new (js__$Boot_HaxeError().default)(error2);
					}
				} else {
					throw error;
				}
			}
		}
		if(!ConcreteRectangleTexture.sAsyncUploadEnabled) {
			(haxe_Timer().default).delay(function() {
				_gthis.get_base().dispatchEvent(new (openfl_events_Event().default)("textureReady"));
			},1);
			this.get_rectBase().uploadFromBitmapData(source);
		}
	},
	onTextureReady: function(event) {
		this.get_base().removeEventListener("textureReady",$bind(this,this.onTextureReady));
		this.get_base().removeEventListener("error",$bind(this,this.onTextureReady));
		if(this._textureReadyCallback != null) {
			this._textureReadyCallback(this);
		}
		this._textureReadyCallback = null;
	}
});
ConcreteRectangleTexture.prototype.__class__ = ConcreteRectangleTexture.prototype.constructor = $hxClasses["starling.textures.ConcreteRectangleTexture"] = ConcreteRectangleTexture;

// Init

Object.defineProperties(ConcreteRectangleTexture.prototype,{ rectBase : { get : function () { return this.get_rectBase (); }}});

// Statics

ConcreteRectangleTexture.get_asyncUploadEnabled = function() {
	return ConcreteRectangleTexture.sAsyncUploadEnabled;
}
ConcreteRectangleTexture.set_asyncUploadEnabled = function(value) {
	return ConcreteRectangleTexture.sAsyncUploadEnabled = value;
}
ConcreteRectangleTexture.sAsyncUploadEnabled = false

// Export

exports.default = ConcreteRectangleTexture;